import styled from 'styled-components';
import { STYLES } from '../../../style';

const Paragraph = styled.p`
  line-height: ${STYLES.LINE_HEIGHT_LG};
`;

export { Paragraph };